export default class Selector {
  static single(onlyImage: boolean = false): Promise<FileList> {
    return Selector.open(onlyImage);
  }

  static multi(onlyImage: boolean = false): Promise<FileList> {
    return Selector.open(onlyImage);
  }

  static open(onlyImage: boolean): Promise<FileList> {
    return new Promise((resolve, reject) => {
      const fileSelector = document.createElement('input');
      fileSelector.setAttribute('type', 'file');

      // 사진 업로드시 용량 문제로 인하여 주석처리 합니다.
      // if (isMulti) fileSelector.setAttribute('multiple', 'multiple');
      if (onlyImage) fileSelector.setAttribute('accept', '.png,.jpg,.jpeg');

      fileSelector.onchange = () => {
        // @ts-ignore
        resolve(fileSelector.files);
      };
      fileSelector.oncancel = reject;
      fileSelector.click();
    });
  }
}
